"use client";

import { UserMissionItemModel } from "@api/models";
import { FreeTicketIcon } from "./Icons";
import Link from "next/link";
import { dateWithHour } from "@lib/utils";
import { DAYS } from "app/(app)/(common)/(common)/category/[categoryName]/CategoryPage";
import { MdHelpOutline } from "react-icons/md";
import { GLOBALS } from "config";
import clsx from "clsx";
import { STORE_KEYS } from "app/constants";
import { useStaticStore } from "app/hooks";

export function MissionListItem({
  mission,
  startDayOfWeeklyMission,
  isToast,
  isPopUp,
}: {
  mission: UserMissionItemModel;
  startDayOfWeeklyMission?: number;
  isToast?: boolean;
  isPopUp?: boolean;
}) {
  let missionCompleted = false;
  if (
    mission.achievementCount &&
    mission.targetAchievementCount &&
    mission.achievementCount >= mission.targetAchievementCount
  ) {
    missionCompleted = true;
  }
  const { mutate } = useStaticStore(STORE_KEYS.popup);

  const handleClick = () => {
    if (isPopUp) {
      mutate(false);
    }
  };
  const isFailure = mission.status === 1;
  if (isPopUp && isFailure) return <></>;

  const toastMainContent = (
    <>
      <p className="mission-list-item-name mode-toast">{mission.title}</p>
      {missionCompleted ? (
        <p className="mission-list-item-name mode-toast">を達成</p>
      ) : (
        <div className="mission-list-item-progress mode-toast">
          <span className="mission-list-item-progress-bar-wrap">
            <progress
              max={mission.targetAchievementCount}
              value={mission.achievementCount}
              className="mission-list-item-progress-bar"
            ></progress>
            <span className="mission-list-item-progress-num mode-toast">
              {mission.achievementCount}/{mission.targetAchievementCount}
            </span>
          </span>
        </div>
      )}
    </>
  );

  const content = (
    <>
      <div className={clsx("mission-list-item-bonus", isToast && "mode-toast")}>
        <div className="mission-list-item-ticket">
          <FreeTicketIcon
            size={18}
            className={clsx(
              "mission-list-item-ticket-icon",
              isToast && "mode-toast",
              ((isToast && !missionCompleted) || isFailure) && "mode-gray",
            )}
          />
        </div>
        <div className="mission-list-item-ticket-label">
          {mission.rewardTicketNumber}
          <span className="mission-list-item-ticket-unit">枚</span>
        </div>
      </div>
      <div className="mission-list-item-main">
        {isToast ? (
          toastMainContent
        ) : (
          <>
            <p className="mission-list-item-name">{mission.title}</p>
            <div className="mission-list-item-progress">
              <span className="mission-list-item-progress-bar-wrap">
                <progress
                  max={mission.targetAchievementCount}
                  value={mission.achievementCount}
                  className="mission-list-item-progress-bar"
                ></progress>
                <span className="mission-list-item-progress-num">
                  {mission.achievementCount}/{mission.targetAchievementCount}
                </span>
              </span>
              {mission.linkDestination && (
                <span className={"mission-list-item-button" + (isFailure ? "" : " mode-active")}>
                  GO
                </span>
              )}
            </div>
            {mission.promotionId === GLOBALS.SHARE_MISSION_PROMOTION_ID && (
              <a
                href={GLOBALS.SHARE_BUTTON_HELP_URL}
                className="mission-help"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MdHelpOutline className="mission-help-icon" size={16} />
                <div className="mission-help-text">シェアボタンの場所を確認する</div>
              </a>
            )}
            {isFailure ? (
              <p className="mission-list-item-failure">
                達成できませんでした。
                {startDayOfWeeklyMission &&
                  `${DAYS[(startDayOfWeeklyMission + 6) % 7]}曜から再チャレンジしよう!`}
              </p>
            ) : mission.endDate ? (
              <p className="mission-list-item-limit">期限：{dateWithHour(mission.endDate)}まで</p>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </>
  );
  return (
    <div
      className={
        "mission-list-item" + (missionCompleted && !isToast ? " mode-achieved" : " mode-active")
      }
    >
      {mission.linkDestination && !isFailure && (
        <Link
          className="mission-list-item-link"
          href={mission.linkDestination || ""}
          onClick={handleClick}
        >
          {content}
        </Link>
      )}
      {(!mission.linkDestination || isFailure) && (
        <span className={clsx("mission-list-item-link mode-no-link", isToast && "mode-toast")}>
          {content}
        </span>
      )}
    </div>
  );
}
